import moment from "moment";

/**
 * Difference between the current timezone and UTC in milliseconds
 */
const utcOffset = moment().utcOffset() * 60000;
export default utcOffset;